import { get } from "lodash-es";
import { defineStore } from "pinia";

import { store } from "@/store";

import { useUserStoreHook } from "./user";

export const useHttpStore = defineStore({
  id: "sys-http",
  state: () => ({
    headers: {}
  }),
  actions: {
    setHeaders(headers) {
      const { user } = useUserStoreHook();
      headers["y-platform-vendor-partner"] =
        get(user, "vendor.partnerRef.key") || "";
      this.headers = headers;
    },
    setHeader(key, value) {
      this.headers[key] = value;
    }
  }
});

export function useHttpStoreHook() {
  return useHttpStore(store);
}
